// 物料信息-详情
import { useEffect, useReducer } from 'react'
import { Button, Form, Skeleton, Space, Divider } from 'antd'
import Maininfo from '../../modules/goodsdetailmodules/maininfo'
import Expandattr from '../../modules/goodsdetailmodules/expandattr'
import Uploadimg from '../../modules/goodsdetailmodules/uploadimg'
import AptitudeAttach from '../../modules/goodsdetailmodules/AptitudeAttach'
import Style from './goodsmanage.module.scss'
import { GET_PRODUCT_DETAIL } from '../../api/MaterialApi'
import { GET_CATEGORY_FRONTEND_HINT_TEXT } from '@/api/categoryQualificationApi'
import { history, useTypedSelector } from '../../redux/store'
import { useDispatch } from 'react-redux'
import {
  setformStateInitAction,
  setformStateAction,
} from '../../modules/ControlformState'
import { useLocation } from 'react-router-dom'
import { setModuleDataAction } from '../../modules/pagecache'
import CustomModal from '../../components/ModalUser'
import Record from './components/record'
import useHook from './hook'
import Originalpic from '../../modules/goodsdetailmodules/originalpic'
import { RoleType, isResponseCodeSuccess } from '../../tools/util'
import Mainpic from '../../modules/goodsdetailmodules/mainpic'
import Secondaryinfo from '../../modules/goodsdetailmodules/secondaryinfo'
import MaterialType from '../../modules/goodsdetailmodules/materialType'
import AssociationItems from '../../modules/goodsdetailmodules/associationItems'
import ExternalLink, {
  ExternalLinkType,
} from '@/modules/goodsdetailmodules/externallink'

const ACTION_TYPE = {
  SET_CURRENT_PARAM: 'set_current_param', // 设置当前页面参数
  CHANGE_DATA: 'CHANGE_DATA', // 替换所有状态
}
interface State {
  currentparam: nowpagesparam // 当前参数
}
interface nowpagesparam {
  tempId?: string // 暂存商品 id
  childId?: string // 子商品 id
  // 选中的tree层级
  selectTreeData?: treeType
  BtnState?: MaterialDetailType[] // 模块状态
}
export interface treeType {
  id: string // 树 id
  title: string // 树名称
  level: string // 树层级
  parentId?: string // 父级id
}
const defaultState: State = {
  currentparam: {},
}
const reducer = (state: State, action: { type: string; value?: any }) => {
  let arr = { ...state }
  switch (action.type) {
    case ACTION_TYPE.SET_CURRENT_PARAM:
      arr.currentparam = action.value
      return arr
    case ACTION_TYPE.CHANGE_DATA:
      arr = action.value
      return arr
    default:
      return { ...state }
  }
}

// 重新加载数据
const reloadDataAction = (params: State) => ({
  type: ACTION_TYPE.CHANGE_DATA,
  value: params,
})

// 路由参数
interface RouteParam extends nowpagesparam {
  init?: boolean // 是否初始化
  copydata?: any // copy
}

const Goodsdetail = () => {
  const {
    usehookstate,
    form,
    platform_form,
    onChangePic,
    onChangeAptitude,
    onChangeDetailPic,
    onChangeCate,
    onChangeBrandSale,
    onClickClose,
    onCancelrecord,
    onChangeLoading,
    reloaddata,
    tempCode,
    onChangeDelivery,
    setMaterialType,
    formatFormFields,
    changeItemList,
    onFieldsChange,
    externalLinkList,
    setExternalLinkList,
    setQualityDataList,
    setDetailAuditType,
  } = useHook()
  const [pagesstate, dispatch] = useReducer(reducer, defaultState)
  const dispatchRedux = useDispatch()
  const {
    pictures,
    qualDocFileList,
    requiredAttachTypes,
    frontendHintText,
    detailPic,
    productCode,
    fieldList,
    isRecord,
    loadingPage,
    hasDelivery,
    unitDisabled,
    materialType,
    itemsList,
    qualityDataList,
  } = usehookstate
  const { childId } = pagesstate.currentparam
  const { role } = useTypedSelector((state) => state.authtoken)
  const { pagekey } = useTypedSelector((state) => state.pageCache)
  const location = useLocation<RouteParam>()
  const { state } = location
  useEffect(() => {
    const flag = getpagecache()
    if (flag && !state) {
      // 读取缓存的公共模块状态
      reloaddata(flag.commonState)
      // 设置form数据
      form.setFieldsValue(flag.formState)
      // 读取缓存的当前模块状态
      dispatch(reloadDataAction(flag.pageState))
      // 判断物料属性
      materialattrDisabled(flag.pageState.currentparam.BtnState)
    } else if (state) {
      dispatchRedux(setformStateInitAction())
      materialattrDisabled(state.BtnState)
      getProductInfo(state)
      form.setFieldsValue({ childId: state.childId }) // 设置物料id 如果为新增则是空 用于maininfo页面判断
    }
    // eslint-disable-next-line
  }, [])

  useEffect(() => {
    // 缓存存数据
    const pathName = history.location.pathname + 'goodsCheck'
    const formstate = form.getFieldsValue()
    const action = setModuleDataAction({
      key: pathName,
      data: {
        commonState: usehookstate, // 公共状态
        pageState: pagesstate, // 当前状态
        formState: formstate,
      },
    })
    dispatchRedux(action)
    return () => {
      const formstate = form.getFieldsValue()
      const action = setModuleDataAction({
        key: pathName,
        data: {
          commonState: usehookstate, // 公共状态
          pageState: pagesstate, // 当前状态
          formState: formstate,
        },
      })
      dispatchRedux(action)
    }
    // eslint-disable-next-line
  }, [usehookstate, pagesstate])

  const handleLinkChange = (newList: ExternalLinkType[]) => {
    setExternalLinkList(newList)
  }

  // 编辑获取数据
  const getProductInfo = async (state: any) => {
    onChangeLoading(true)
    const res = await GET_PRODUCT_DETAIL({
      productId: state.productId,
    })
    if (isResponseCodeSuccess(res.code)) {
      const resData = res.data
      // 资质场景：依据详情返参 auditType（ADD/MODIFY）推算
      setDetailAuditType(resData.auditType)
      // 初始进入详情：通过类目 ID 调接口获取当前四级类目的前台提示文案
      const hintRes = await GET_CATEGORY_FRONTEND_HINT_TEXT({
        categoryId: resData.fourthCateMdmId,
      })
      const frontendHintText = isResponseCodeSuccess(hintRes.code)
        ? hintRes.data
        : ''
      await onChangeCate(
        resData.fourthCateMdmId,
        undefined,
        resData.code,
        frontendHintText,
      )
      const formatData = formatFormFields(resData)
      form.setFieldsValue(formatData)
      const newExternalLinks = resData.externalLinks.map((item: any) => {
        return {
          ...item,
          externalFile: item.externalFile ? JSON.parse(item.externalFile) : [],
        }
      })

      setExternalLinkList(newExternalLinks)
    }
    onChangeLoading(false)
  }
  // 获取数据
  const getpagecache = () => {
    const pathName = history.location.pathname + 'goodsCheck'
    const data = pagekey.filter((item) => item.key === pathName)
    if (data.length === 1) {
      return data[0].data
    }
    return null
  }

  // 物料属性是否可修改
  const materialattrDisabled = (params?: MaterialDetailType[]) => {
    let flag = false
    if (role === RoleType.SOURCE_PURCHASE_MAN && params) {
      // 采购员 物料属性
      flag = params.indexOf('Add') !== -1 ? false : true
    }
    dispatchRedux(setformStateAction([{ key: 'materialattr', disabled: flag }]))
  }

  // 按钮类型
  const ButtonComponents = () => {
    const EditBtn = null
    const EditChild = null
    const DisableBtn = null
    const UndisableBtn = null
    const CopyBtn = null
    return (
      <div className={Style.btnbox}>
        <div className={Style['btn-left-box']}></div>
        <div className={Style['btn-center-box']}></div>
        <div className={Style['btn-right-box']}>
          <Space>
            {EditBtn}
            {EditChild}
            {DisableBtn}
            {UndisableBtn}
            {CopyBtn}
            <Button type="link" size="small" onClick={onClickClose}>
              关闭
            </Button>
          </Space>
        </div>
      </div>
    )
  }

  return (
    <Form.Provider>
      <ButtonComponents />
      <div className={Style.container}>
        <div className={Style.box}>
          <Skeleton loading={loadingPage} active>
            <MaterialType
              form={form}
              onFieldsChange={onFieldsChange}
              setMaterialType={setMaterialType}
              type="single"
            />
          </Skeleton>
        </div>
        <div className={Style.box}>
          <div className={Style.boxtitle}>
            <span>主要信息</span>
          </div>
          <Divider style={{ margin: '0' }} />
          <Skeleton loading={loadingPage} active>
            <Maininfo
              form={form}
              onFieldsChange={onFieldsChange}
              onChangeCate={onChangeCate}
              onChangeSale={onChangeBrandSale}
              tempCode={tempCode}
              unitDisabled={unitDisabled}
              materialType={materialType}
            />
          </Skeleton>
        </div>
        <div className={Style.box}>
          <div className={Style.boxtitle}>
            <span>次要信息</span>
          </div>
          <Divider style={{ margin: '0' }} />
          <Skeleton loading={loadingPage} active>
            <Secondaryinfo
              form={form}
              onFieldsChange={onFieldsChange}
              onChangeDelivery={onChangeDelivery}
              hasDelivery={hasDelivery}
            />
          </Skeleton>
        </div>
        {(materialType === '1' || materialType === '2') && (
          <div className={Style.box}>
            <div className={Style.boxtitle}>
              <span>关联项目信息</span>
            </div>
            <Divider style={{ margin: '0' }} />
            <Skeleton loading={loadingPage} active>
              <AssociationItems
                form={platform_form}
                normalForm={form}
                readOnly
                itemsList={itemsList}
                changeItemList={changeItemList}
                onFieldsChange={onFieldsChange}
                qualityDataList={qualityDataList}
                setQualityDataListAction={setQualityDataList}
              />
            </Skeleton>
          </div>
        )}
        <div className={Style.box}>
          <div className={Style.boxtitle}>
            <span>拓展属性</span>
            <span className={Style.tips}>
              拓展属性标题为<span className={Style.blueTip}>蓝色</span>
              代表有平台项目对该拓展属性有要求，鼠标移到拓展属性标题即可查看具体平台项目。
              <span
                style={{
                  color: '#8C8C8C',
                  fontSize: '12px',
                  lineHeight: '24px',
                }}
              >
                都需填写，无法填写的填/【如果是大批量无法填写，可能是四级类目选错】
              </span>
            </span>
          </div>
          <Divider style={{ margin: '0' }} />
          <Skeleton loading={loadingPage} active>
            <Expandattr
              form={form}
              onFieldsChange={onFieldsChange}
              fieldList={fieldList}
              itemsList={itemsList}
              frontendHintText={frontendHintText}
            />
          </Skeleton>
        </div>
        <div className={Style.box}>
          <Divider style={{ margin: '0' }} />
          <AptitudeAttach
            dataSource={qualDocFileList}
            onChange={onChangeAptitude}
            productCode={productCode}
            loading={loadingPage}
            requiredAttachTypes={requiredAttachTypes}
          />
        </div>
        <div className={Style.box}>
          <div className={Style.boxtitle}>
            <span>外部链接/价格佐证</span>
          </div>
          <Divider style={{ margin: '0' }} />
          <Skeleton loading={loadingPage} active>
            <ExternalLink
              form={form}
              externalLinkList={externalLinkList}
              onLinkChange={handleLinkChange}
            />
          </Skeleton>
        </div>
        <div className={Style.box}>
          <div className={Style.boxtitle}>
            <span>图文信息</span>
          </div>
          <Divider style={{ margin: '0' }} />
          <Skeleton loading={loadingPage} active>
            <div className={Style.picinfobox}>
              {/* <div className={Style.picinfotitle}>
                <span className={Style.text}>图片关系</span>
              </div> */}
              {/* true 显示 匹配、类似 注意必填校验 */}
              <Mainpic required form={form} onFieldsChange={onFieldsChange} />
              <div className={Style.picinfotitle}>
                <span className={Style.text}>
                  主图：
                  <span
                    style={{
                      color: '#8C8C8C',
                      fontSize: '12px',
                      lineHeight: '24px',
                    }}
                  >
                    尺寸：800×800 px。建议上传3张及以上，最多20张。第一张白底，其它尽量白底。主图要求颜色唯一，需要与描述或者拓展属性值一致【最低标准∶不低于在其他平台上架的标准】
                  </span>
                </span>
              </div>
              <Uploadimg
                dataSource={pictures}
                onChange={onChangePic}
                tempCode={tempCode}
                maxCount={20}
                dragable
              />
              <div hidden>
                <Originalpic
                  required={false}
                  form={form}
                  onFieldsChange={onFieldsChange}
                />
              </div>
              <div className={Style.picinfotitle}>
                <span className={Style.text}>
                  详情图：
                  <span
                    style={{
                      color: '#8C8C8C',
                      fontSize: '12px',
                      lineHeight: '24px',
                    }}
                  >
                    上传图片宽度不小于500 px，高度不限，最多100张。要图文丰富，需包含产品图、细节图、参数图、使用场景图，【最低标准:不低于在其他平台上架的标准】。一定不能包含:7天无理由退换货、送货上门、免费开票、水印、其它店铺信息、质保、包邮、链接、二维码、电话号码......等敏感词汇
                  </span>
                </span>
              </div>
              <Uploadimg
                dataSource={detailPic}
                onChange={onChangeDetailPic}
                tempCode={tempCode}
                isDetailPic
                maxCount={100}
                dragable
              />
            </div>
          </Skeleton>
        </div>

        <CustomModal
          title="操作记录"
          open={isRecord}
          modalCancel={onCancelrecord}
          footer={false}
        >
          <Record type={1} id={childId} />
        </CustomModal>
      </div>
    </Form.Provider>
  )
}

export default Goodsdetail

type MaterialDetailType =
  // 新增
  | 'Add'
  // 编辑
  | 'Edit'
  // 详情
  | 'Detail'
  // 禁用
  | 'Disable'
  // 启用
  | 'Undisable'
  // 复制
  | 'Copy'
// 物料信息-详情
import { useEffect, useReducer } from 'react'
import { Button, Form, Skeleton, Space, Divider } from 'antd'
import Maininfo from '../../modules/goodsdetailmodules/maininfo'
import Expandattr from '../../modules/goodsdetailmodules/expandattr'
import Uploadimg from '../../modules/goodsdetailmodules/uploadimg'
import AptitudeAttach from '../../modules/goodsdetailmodules/AptitudeAttach'
import Style from './goodsmanage.module.scss'
import { GET_PRODUCT_DETAIL } from '../../api/MaterialApi'
import { GET_CATEGORY_FRONTEND_HINT_TEXT } from '@/api/categoryQualificationApi'
import { history, useTypedSelector } from '../../redux/store'
import { useDispatch } from 'react-redux'
import {
  setformStateInitAction,
  setformStateAction,
} from '../../modules/ControlformState'
import { useLocation } from 'react-router-dom'
import { setModuleDataAction } from '../../modules/pagecache'
import CustomModal from '../../components/ModalUser'
import Record from './components/record'
import useHook from './hook'
import Originalpic from '../../modules/goodsdetailmodules/originalpic'
import { RoleType, isResponseCodeSuccess } from '../../tools/util'
import Mainpic from '../../modules/goodsdetailmodules/mainpic'
import Secondaryinfo from '../../modules/goodsdetailmodules/secondaryinfo'
import MaterialType from '../../modules/goodsdetailmodules/materialType'
import AssociationItems from '../../modules/goodsdetailmodules/associationItems'
import ExternalLink, {
  ExternalLinkType,
} from '@/modules/goodsdetailmodules/externallink'

const ACTION_TYPE = {
  SET_CURRENT_PARAM: 'set_current_param', // 设置当前页面参数
  CHANGE_DATA: 'CHANGE_DATA', // 替换所有状态
}
interface State {
  currentparam: nowpagesparam // 当前参数
}
interface nowpagesparam {
  tempId?: string // 暂存商品 id
  childId?: string // 子商品 id
  // 选中的tree层级
  selectTreeData?: treeType
  BtnState?: MaterialDetailType[] // 模块状态
}
export interface treeType {
  id: string // 树 id
  title: string // 树名称
  level: string // 树层级
  parentId?: string // 父级id
}
const defaultState: State = {
  currentparam: {},
}
const reducer = (state: State, action: { type: string; value?: any }) => {
  let arr = { ...state }
  switch (action.type) {
    case ACTION_TYPE.SET_CURRENT_PARAM:
      arr.currentparam = action.value
      return arr
    case ACTION_TYPE.CHANGE_DATA:
      arr = action.value
      return arr
    default:
      return { ...state }
  }
}

// 重新加载数据
const reloadDataAction = (params: State) => ({
  type: ACTION_TYPE.CHANGE_DATA,
  value: params,
})

// 路由参数
interface RouteParam extends nowpagesparam {
  init?: boolean // 是否初始化
  copydata?: any // copy
}

const Goodsdetail = () => {
  const {
    usehookstate,
    form,
    platform_form,
    onChangePic,
    onChangeAptitude,
    onChangeDetailPic,
    onChangeCate,
    onChangeBrandSale,
    onClickClose,
    onCancelrecord,
    onChangeLoading,
    reloaddata,
    tempCode,
    onChangeDelivery,
    setMaterialType,
    formatFormFields,
    changeItemList,
    onFieldsChange,
    externalLinkList,
    setExternalLinkList,
    setQualityDataList,
    setDetailAuditType,
  } = useHook()
  const [pagesstate, dispatch] = useReducer(reducer, defaultState)
  const dispatchRedux = useDispatch()
  const {
    pictures,
    qualDocFileList,
    requiredAttachTypes,
    frontendHintText,
    detailPic,
    productCode,
    fieldList,
    isRecord,
    loadingPage,
    hasDelivery,
    unitDisabled,
    materialType,
    itemsList,
    qualityDataList,
  } = usehookstate
  const { childId } = pagesstate.currentparam
  const { role } = useTypedSelector((state) => state.authtoken)
  const { pagekey } = useTypedSelector((state) => state.pageCache)
  const location = useLocation<RouteParam>()
  const { state } = location
  useEffect(() => {
    const flag = getpagecache()
    if (flag && !state) {
      // 读取缓存的公共模块状态
      reloaddata(flag.commonState)
      // 设置form数据
      form.setFieldsValue(flag.formState)
      // 读取缓存的当前模块状态
      dispatch(reloadDataAction(flag.pageState))
      // 判断物料属性
      materialattrDisabled(flag.pageState.currentparam.BtnState)
    } else if (state) {
      dispatchRedux(setformStateInitAction())
      materialattrDisabled(state.BtnState)
      getProductInfo(state)
      form.setFieldsValue({ childId: state.childId }) // 设置物料id 如果为新增则是空 用于maininfo页面判断
    }
    // eslint-disable-next-line
  }, [])

  useEffect(() => {
    // 缓存存数据
    const pathName = history.location.pathname + 'goodsCheck'
    const formstate = form.getFieldsValue()
    const action = setModuleDataAction({
      key: pathName,
      data: {
        commonState: usehookstate, // 公共状态
        pageState: pagesstate, // 当前状态
        formState: formstate,
      },
    })
    dispatchRedux(action)
    return () => {
      const formstate = form.getFieldsValue()
      const action = setModuleDataAction({
        key: pathName,
        data: {
          commonState: usehookstate, // 公共状态
          pageState: pagesstate, // 当前状态
          formState: formstate,
        },
      })
      dispatchRedux(action)
    }
    // eslint-disable-next-line
  }, [usehookstate, pagesstate])

  const handleLinkChange = (newList: ExternalLinkType[]) => {
    setExternalLinkList(newList)
  }

  // 编辑获取数据
  const getProductInfo = async (state: any) => {
    onChangeLoading(true)
    const res = await GET_PRODUCT_DETAIL({
      productId: state.productId,
    })
    if (isResponseCodeSuccess(res.code)) {
      const resData = res.data
      // 资质场景：依据详情返参 auditType（ADD/MODIFY）推算
      setDetailAuditType(resData.auditType)
      // 初始进入详情：通过类目 ID 调接口获取当前四级类目的前台提示文案
      const hintRes = await GET_CATEGORY_FRONTEND_HINT_TEXT({
        categoryId: resData.fourthCateMdmId,
      })
      const frontendHintText = isResponseCodeSuccess(hintRes.code)
        ? hintRes.data
        : ''
      await onChangeCate(
        resData.fourthCateMdmId,
        undefined,
        resData.code,
        frontendHintText,
      )
      const formatData = formatFormFields(resData)
      form.setFieldsValue(formatData)
      const newExternalLinks = resData.externalLinks.map((item: any) => {
        return {
          ...item,
          externalFile: item.externalFile ? JSON.parse(item.externalFile) : [],
        }
      })

      setExternalLinkList(newExternalLinks)
    }
    onChangeLoading(false)
  }
  // 获取数据
  const getpagecache = () => {
    const pathName = history.location.pathname + 'goodsCheck'
    const data = pagekey.filter((item) => item.key === pathName)
    if (data.length === 1) {
      return data[0].data
    }
    return null
  }

  // 物料属性是否可修改
  const materialattrDisabled = (params?: MaterialDetailType[]) => {
    let flag = false
    if (role === RoleType.SOURCE_PURCHASE_MAN && params) {
      // 采购员 物料属性
      flag = params.indexOf('Add') !== -1 ? false : true
    }
    dispatchRedux(setformStateAction([{ key: 'materialattr', disabled: flag }]))
  }

  // 按钮类型
  const ButtonComponents = () => {
    const EditBtn = null
    const EditChild = null
    const DisableBtn = null
    const UndisableBtn = null
    const CopyBtn = null
    return (
      <div className={Style.btnbox}>
        <div className={Style['btn-left-box']}></div>
        <div className={Style['btn-center-box']}></div>
        <div className={Style['btn-right-box']}>
          <Space>
            {EditBtn}
            {EditChild}
            {DisableBtn}
            {UndisableBtn}
            {CopyBtn}
            <Button type="link" size="small" onClick={onClickClose}>
              关闭
            </Button>
          </Space>
        </div>
      </div>
    )
  }

  return (
    <Form.Provider>
      <ButtonComponents />
      <div className={Style.container}>
        <div className={Style.box}>
          <Skeleton loading={loadingPage} active>
            <MaterialType
              form={form}
              onFieldsChange={onFieldsChange}
              setMaterialType={setMaterialType}
              type="single"
            />
          </Skeleton>
        </div>
        <div className={Style.box}>
          <div className={Style.boxtitle}>
            <span>主要信息</span>
          </div>
          <Divider style={{ margin: '0' }} />
          <Skeleton loading={loadingPage} active>
            <Maininfo
              form={form}
              onFieldsChange={onFieldsChange}
              onChangeCate={onChangeCate}
              onChangeSale={onChangeBrandSale}
              tempCode={tempCode}
              unitDisabled={unitDisabled}
              materialType={materialType}
            />
          </Skeleton>
        </div>
        <div className={Style.box}>
          <div className={Style.boxtitle}>
            <span>次要信息</span>
          </div>
          <Divider style={{ margin: '0' }} />
          <Skeleton loading={loadingPage} active>
            <Secondaryinfo
              form={form}
              onFieldsChange={onFieldsChange}
              onChangeDelivery={onChangeDelivery}
              hasDelivery={hasDelivery}
            />
          </Skeleton>
        </div>
        {(materialType === '1' || materialType === '2') && (
          <div className={Style.box}>
            <div className={Style.boxtitle}>
              <span>关联项目信息</span>
            </div>
            <Divider style={{ margin: '0' }} />
            <Skeleton loading={loadingPage} active>
              <AssociationItems
                form={platform_form}
                normalForm={form}
                readOnly
                itemsList={itemsList}
                changeItemList={changeItemList}
                onFieldsChange={onFieldsChange}
                qualityDataList={qualityDataList}
                setQualityDataListAction={setQualityDataList}
              />
            </Skeleton>
          </div>
        )}
        <div className={Style.box}>
          <div className={Style.boxtitle}>
            <span>拓展属性</span>
            <span className={Style.tips}>
              拓展属性标题为<span className={Style.blueTip}>蓝色</span>
              代表有平台项目对该拓展属性有要求，鼠标移到拓展属性标题即可查看具体平台项目。
              <span
                style={{
                  color: '#8C8C8C',
                  fontSize: '12px',
                  lineHeight: '24px',
                }}
              >
                都需填写，无法填写的填/【如果是大批量无法填写，可能是四级类目选错】
              </span>
            </span>
          </div>
          <Divider style={{ margin: '0' }} />
          <Skeleton loading={loadingPage} active>
            <Expandattr
              form={form}
              onFieldsChange={onFieldsChange}
              fieldList={fieldList}
              itemsList={itemsList}
              frontendHintText={frontendHintText}
            />
          </Skeleton>
        </div>
        <div className={Style.box}>
          <Divider style={{ margin: '0' }} />
          <AptitudeAttach
            dataSource={qualDocFileList}
            onChange={onChangeAptitude}
            productCode={productCode}
            loading={loadingPage}
            requiredAttachTypes={requiredAttachTypes}
          />
        </div>
        <div className={Style.box}>
          <div className={Style.boxtitle}>
            <span>外部链接/价格佐证</span>
          </div>
          <Divider style={{ margin: '0' }} />
          <Skeleton loading={loadingPage} active>
            <ExternalLink
              form={form}
              externalLinkList={externalLinkList}
              onLinkChange={handleLinkChange}
            />
          </Skeleton>
        </div>
        <div className={Style.box}>
          <div className={Style.boxtitle}>
            <span>图文信息</span>
          </div>
          <Divider style={{ margin: '0' }} />
          <Skeleton loading={loadingPage} active>
            <div className={Style.picinfobox}>
              {/* <div className={Style.picinfotitle}>
                <span className={Style.text}>图片关系</span>
              </div> */}
              {/* true 显示 匹配、类似 注意必填校验 */}
              <Mainpic required form={form} onFieldsChange={onFieldsChange} />
              <div className={Style.picinfotitle}>
                <span className={Style.text}>
                  主图：
                  <span
                    style={{
                      color: '#8C8C8C',
                      fontSize: '12px',
                      lineHeight: '24px',
                    }}
                  >
                    尺寸：800×800 px。建议上传3张及以上，最多20张。第一张白底，其它尽量白底。主图要求颜色唯一，需要与描述或者拓展属性值一致【最低标准∶不低于在其他平台上架的标准】
                  </span>
                </span>
              </div>
              <Uploadimg
                dataSource={pictures}
                onChange={onChangePic}
                tempCode={tempCode}
                maxCount={20}
                dragable
              />
              <div hidden>
                <Originalpic
                  required={false}
                  form={form}
                  onFieldsChange={onFieldsChange}
                />
              </div>
              <div className={Style.picinfotitle}>
                <span className={Style.text}>
                  详情图：
                  <span
                    style={{
                      color: '#8C8C8C',
                      fontSize: '12px',
                      lineHeight: '24px',
                    }}
                  >
                    上传图片宽度不小于500 px，高度不限，最多100张。要图文丰富，需包含产品图、细节图、参数图、使用场景图，【最低标准:不低于在其他平台上架的标准】。一定不能包含:7天无理由退换货、送货上门、免费开票、水印、其它店铺信息、质保、包邮、链接、二维码、电话号码......等敏感词汇
                  </span>
                </span>
              </div>
              <Uploadimg
                dataSource={detailPic}
                onChange={onChangeDetailPic}
                tempCode={tempCode}
                isDetailPic
                maxCount={100}
                dragable
              />
            </div>
          </Skeleton>
        </div>

        <CustomModal
          title="操作记录"
          open={isRecord}
          modalCancel={onCancelrecord}
          footer={false}
        >
          <Record type={1} id={childId} />
        </CustomModal>
      </div>
    </Form.Provider>
  )
}

export default Goodsdetail

type MaterialDetailType =
  // 新增
  | 'Add'
  // 编辑
  | 'Edit'
  // 详情
  | 'Detail'
  // 禁用
  | 'Disable'
  // 启用
  | 'Undisable'
  // 复制
  | 'Copy'
